<template>
  <DataListStateful
    title="Перевозчики"
    resource="carriers"
    store="carriers"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        {
          title: "Телефон",
          name: "phones",
          sortable: true,
          valueFn(item) {
            return item.Phones.length > 1
              ? item.Phones.join("; ")
              : item.Phones.join();
          },
        },
        {
          title: "Email",
          name: "emails",
          sortable: true,
          valueFn(item) {
            return item.Emails.length > 1
              ? item.Emails.join("; ")
              : item.Emails.join();
          },
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
      },
    };
  },
};
</script>
